import { Box } from '@mui/material';
import { SELECTED_LANGUAGE } from 'constants/localStorageConstants';
import { useTranslation } from 'react-i18next';
import { lazy, Suspense } from 'react';

const LanguageSwitcher = lazy(() => import('components/elements/LanguageSwitcher'));

const styles = {
	main: {
		height: '100%'
	},
	switcher: {
		position: 'fixed',
		bottom: 0
	}
};

const LanguageSwitcherWrap = ({ children }) => {
	const { i18n } = useTranslation();
	const selectedLanguage = localStorage.getItem(SELECTED_LANGUAGE);

	const handleSwitchLanguage = async l => {
		await i18n.changeLanguage(l);
		localStorage.setItem(SELECTED_LANGUAGE, l);
	};

	return (
		<Box sx={styles.main}>
			{children}
			<Box sx={styles.switcher}>
				<Suspense fallback={<div>LOADING</div>}>
					<LanguageSwitcher value={selectedLanguage} onChange={handleSwitchLanguage} />
				</Suspense>
			</Box>
		</Box>
	);
};

export default LanguageSwitcherWrap;
